/**
 * Maison — Personalise proxy
 *
 * The visible button in Maison Product Accordion ([data-maison-personalize-proxy])
 * forwards its click to the hidden source button in Maison Buy Buttons
 * ([data-maison-personalize-source]), matched by product id.
 *
 * Cases:
 *  - Required customization: no proxy is rendered (handled in Liquid).
 *  - Optional, block set to "Drawer": source opens the size drawer; the drawer
 *    enforces size selection. Proxy just forwards.
 *  - Optional, one-size: source opens the personalisation dialog. Proxy just forwards.
 *  - Optional, sizes, block set to "Page": if no size has been picked yet
 *    (source has data-maison-needs-size), the proxy scrolls to the size picker
 *    instead. Once a size is picked (variant:update), it forwards normally.
 */
(() => {
  if (window.__maisonPersonalizeProxy) return; // avoid double-binding
  window.__maisonPersonalizeProxy = true;

  // product ids for which the customer has picked a size on this page
  const sizePicked = new Set();

  const findSource = (id) =>
    document.querySelector(`[data-maison-personalize-source="${id}"]`);

  function scrollToSizePicker(source) {
    const picker =
      source.parentElement?.querySelector('.maison-size-picker') ||
      document.querySelector('#maison-buy-buttons .maison-size-picker');
    if (!picker) return false;
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const firstOption = picker.querySelector('input:not([disabled]), button:not([disabled]), select');
    if (firstOption) firstOption.focus({ preventScroll: true });
    return true;
  }

  document.addEventListener('click', (e) => {
    const proxy = e.target.closest('[data-maison-personalize-proxy]');
    if (!proxy) return;
    e.preventDefault();

    const id = proxy.dataset.maisonPersonalizeProxy;
    const source = findSource(id);
    if (!source) {
      console.warn('[maison] personalize source not found for', id);
      return;
    }

    // Page mode with sizes and nothing picked yet → send them to the sizes first
    if (source.hasAttribute('data-maison-needs-size') && !sizePicked.has(id)) {
      if (scrollToSizePicker(source)) return;
    }

    source.click();
  });

  // A size was picked → stop redirecting to the size picker for that product
  document.addEventListener('variant:update', (e) => {
    const productId =
      e.detail?.data?.productId ?? e.detail?.productId ?? e.detail?.resource?.product_id;
    if (productId) {
      sizePicked.add(String(productId));
    } else {
      // no product id in the event: assume it's the main product
      document
        .querySelectorAll('[data-maison-personalize-source]')
        .forEach((s) => sizePicked.add(s.dataset.maisonPersonalizeSource));
    }
  });
})();